import { useEffect } from 'react';

// Updates the height of a <textarea> when the value changes.
const useAutosizeTextArea = (textAreaRef, value, isFocus, isTextFieldChanged = false) => {
  useEffect(() => {
    const MIN_HEIGHT = 42;
    const FOCUSED_HEIGHT = 96;
    if (textAreaRef) {
      // Reset the height momentarily to get the correct scrollHeight for the textarea
      textAreaRef.style.height = 'auto';

      if (!isFocus && textAreaRef.value.trim() === '' && !isTextFieldChanged) {
        textAreaRef.style.height = MIN_HEIGHT + 'px';
      } else {
        const newHeight = Math.max(FOCUSED_HEIGHT, textAreaRef.scrollHeight);
        textAreaRef.style.height = newHeight + 'px';
      }
    }
  }, [textAreaRef, value, isFocus, isTextFieldChanged]);
};

export default useAutosizeTextArea;
